import React, { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Tabs, Tab, Grid, Grow, Typography } from "@mui/material";
import MyContext from "../../../../contexts/MyContext";
import { lngs, TicketType } from "../../../../Constant";
import { TicketForm1New } from "../ticket-forms/TicketForm1New";

export const Slide1New = (props) => {
  const { t, i18n } = useTranslation();
  const myContext = useContext(MyContext);
  // const [tabIndex, setTabIndex] = useState(myContext.ticketType);

  // useEffect(() => {
  //   myContext.resetState();
  //   myContext.changeTicketType(tabIndex);
  // }, [tabIndex]);

  return (
    <MyContext.Consumer>
      {(context) => (
        <div hidden={context.activeSlide !== 0}>
          <TicketForm1New {...props} />
        </div>
      )}
    </MyContext.Consumer>
  );
};
